export default __webpack_public_path__ + "static/house2-edba226f48be9e93eaca2f6e0446da2f.png";